module.exports = __webpack_public_path__ + "img/45.5d26b202.jpg";